import type { AlignmentPosition } from "@shared/types/options";

export enum DOCS {
  PRIVACY_POLICY = 'privacy_policy',
  TERMS_OF_SERVICE = 'terms_of_service',
  COOKIE_POLICY = 'cookie_policy'
}

export enum UserActivationType {
  EMAIL_AND_PHONE = 'emailAndPhone',
  ZOTLO_ACTIVATION_CODE = 'zotloActivationCode',
  OWN_ACTIVATION_CODE = 'ownActivationCode',
  AUTO_ACTIVATION_CODE = 'autoActivation',
}

export type UserActivationInstruction = {
  instruction: string;
  language: string;
}

export const flexAlignProperty: Record<AlignmentPosition, 'flex-start' | 'flex-end' | 'center'> = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
};
